import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { 
  getAuth, 
  GoogleAuthProvider, 
  GithubAuthProvider, 
  signInWithPopup,
} from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBE-9njCrTXw0g5oPy2nQUkUMXfOcJIqlA",
  authDomain: "a1facts.firebaseapp.com",
  projectId: "a1facts",
  storageBucket: "a1facts.firebasestorage.app",
  messagingSenderId: "14544919854",
  appId: "1:14544919854:web:afd512509815583a76aebf",
  measurementId: "G-YS3KTDYZTG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const githubProvider = new GithubAuthProvider();

export { 
  analytics, 
  auth, 
  googleProvider, 
  githubProvider, 
  signInWithPopup, 
}; 